<template>
  <div class="order-details">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/personal/info' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/personal/info/orders' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">

      <div class="order-module">
        <div class="order-item-title">订单信息</div>
        <div>
          <div class="order-base">
            <span>{{orderDetail.title}}</span>
            <span class="order-id">订单编号: {{orderId}}</span>
          </div>
          <div class="ajie_table">
            <el-table :data="orderData" border align="center">
              <el-table-column label="下单时间" align="center" prop="createTime">
                <template slot-scope="scope">
                  <span type="text" size="small">{{scope.row.createTime | DateFilter('yyyy-MM-dd hh:mm')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="预计金额" align="center" prop="orderFee"></el-table-column>
              <el-table-column label="核准金额" align="center" prop="approvalFee" v-if="orderDetail.approvalFee>0"></el-table-column>
              <el-table-column label="支付金额" align="center" prop="payFee"></el-table-column>
              <el-table-column label="支付时间" align="center" prop="payTime" v-if="orderDetail.payTime">
                <template slot-scope="scope1">
                  <span type="text" size="small">{{scope1.row.payTime | DateFilter('yyyy-MM-dd hh:mm')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="支付单号"  align="center" prop="payLogId"></el-table-column>
              <el-table-column label="订单状态"  align="center" prop="orderStatus"></el-table-column>
            </el-table>
          </div>
          <div>
            <div class="pay-btn">
              <el-button type="danger" round @click="cancelOrder" v-show="cancelBtn">取消订单</el-button>
              <el-button type="danger" round @click="jumpPay" v-show="payBtn">去支付</el-button>
              <el-button type="danger" round @click="rateOrder" v-show="rateBtn">评价</el-button>
            </div>
            <!-- 支付倒计时 -->
            <div v-if="payCloseTime">
              <h3>账单提交成功，请尽快付款！</h3>
              <p>支付剩余：<span class="pay-close-time">{{ time }}</span>，逾期支付，订单将自动取消。</p>
            </div>
            <OrderEvaluate v-show="rateBtn" :showRate="showRate" @closeRate="rateOrder" :orderInfo="orderDetail"></OrderEvaluate>
          </div>
        </div>
      </div>

      <div class="order-module">
        <!-- 自定义服务、入驻办理 -->
        <CustomDemo v-if="orderType === 3 || orderType === 10 || orderType === 19" :info="orderServiceInfo"></CustomDemo>
        <!-- 找工作 -->
        <JobDemo v-if="orderType === 4" :info="orderServiceInfo"></JobDemo>
        <!-- 服务外包 -->
        <ServiceDemo v-if="orderType === 5" :info="orderServiceInfo"></ServiceDemo>
        <!-- 培训 -->
        <TrainingDemo v-if="orderType === 6" :info="orderServiceInfo"></TrainingDemo>
        <!-- 产品路演 -->
        <ProductionDemo v-if="orderType === 7" :info="orderServiceInfo"></ProductionDemo>
        <!-- 求购合作 -->
        <CooperationDemo v-if="orderType === 8" :info="orderServiceInfo"></CooperationDemo>
        <!-- 美食街 -->
        <FoodDemo v-if="orderType === 9" :info="orderServiceInfo"></FoodDemo>
        <!-- 优选服务 -->
        <RecommendedDemo v-if="orderType === 11" :info="orderServiceInfo"></RecommendedDemo>
        <!-- 会议室 -->
        <MeetingRoomDemo v-if="orderType === 12" :info="orderServiceInfo"></MeetingRoomDemo>
        <!-- 园区活动 -->
        <ParkactivityDetails v-if="orderType === 13" :info="orderServiceInfo" ></ParkactivityDetails>
        <!-- 专享福利 -->
        <ParkexclusiveActivities v-if="orderType === 14" :info="orderServiceInfo"></ParkexclusiveActivities>
        <!-- 自定义设施出租 -->
        <CustomOrderDetail v-if="orderType === 16" :info="orderServiceInfo"></CustomOrderDetail>
        <!-- 商城 -->
        <MallDemo v-if="orderType === 17" :info="orderServiceInfo"></MallDemo>
        <!-- 物业报修 -->
        <MaintainDemo v-if="orderType === 18" :info="orderServiceInfo"></MaintainDemo>
      </div>

      <div class="order-module" v-if="orderDetail.remark">
        <div class="remarkTitle">附言</div>
        <p class="remarkText">{{orderDetail.remark}}</p>
      </div>

      <div class="order-module" v-if="orderDetail.linkServiceInfo">
        <LinkServiceContainer :linkServiceInfo="orderDetail.linkServiceInfo" :linkServiceType="orderDetail.linkServiceType"></LinkServiceContainer>
      </div>

      <div class="order-module" v-if="invoiceInfo">
        <div class="order-item-title">发票信息</div>
        <div>
          <el-row :gutter="20">
            <el-col :span="10">
              <span class="text-label">发票类型:</span>
              <span>{{invoiceInfo.invoiceType == 1 ? '普通发票' : '增值税发票'}}</span>
            </el-col>
            <el-col :span="14">
              <span class="text-label">发票抬头: </span>
              <span>{{invoiceInfo.invoiceTitle}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <span class="text-label">收票人手机号: </span>
              <span>{{invoiceInfo.receiverMobile}}</span>
            </el-col>
            <el-col :span="14" v-if="invoiceInfo.type != '2'">
              <span class="text-label">纳税人识别号: </span>
              <span>{{invoiceInfo.creditCode}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="invoiceInfo.invoiceType == '2'">
            <el-col :span="10">
              <span class="text-label">注册地址:</span>
              <span>{{invoiceInfo.registerAddress}}</span>
            </el-col>
            <el-col :span="14">
              <span class="text-label">注册电话:</span>
              <span>{{invoiceInfo.registerTel}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="invoiceInfo.invoiceType == '2'">
            <el-col :span="10">
              <span class="text-label">开户银行: </span>
              <span>{{invoiceInfo.bankName}}</span>
            </el-col>
            <el-col :span="14">
              <span class="text-label">银行账号:</span>
              <span>{{invoiceInfo.bankAccount}}</span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="order-module">
        <div class="order-item-title">个人信息</div>
        <div>
          <el-row :gutter="20">
            <el-col :span="10">
              <span class="text-label">联系人: </span>
              <span>{{ userinfo.applyName }}</span>
            </el-col>
            <el-col :span="10">
              <span class="text-label">职位: </span>
              <span>{{ userinfo.applyPosition }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <span class="text-label">联系电话: </span>
              <span>{{ userinfo.applyPhone }}</span>
            </el-col>
            <el-col :span="10">
              <span class="text-label">公司名称: </span>
              <span>{{userinfo.applyCorpName}}</span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="order-module" v-if="orderStatus == 6 && orderType !== 9">
        <div class="order-item-title">我的评价</div>
        <div>
          <el-rate v-model="orderDetail.servicesScore" :texts="rateText" show-text disabled :colors="['#d0011b', '#d0011b', '#d0011b']" disabled-void-color="#aaa"></el-rate>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomDemo from '@/components/orderDetails/CustomDemo';
import JobDemo from '@/components/orderDetails/JobDemo';
import ServiceDemo from '@/components/orderDetails/ServiceDemo';
import TrainingDemo from '@/components/orderDetails/TrainingDemo';
import ProductionDemo from '@/components/orderDetails/ProductionDemo';
import CooperationDemo from '@/components/orderDetails/CooperationDemo';
import FoodDemo from '@/components/orderDetails/FoodDemo';
import RecommendedDemo from '@/components/orderDetails/RecommendedDemo';
import MeetingRoomDemo from '@/components/orderDetails/MeetingRoomDemo';
import ParkactivityDetails from '@/components/orderDetails/ParkactivityDetails';
import ParkexclusiveActivities from '@/components/orderDetails/ParkexclusiveActivities';
import CustomOrderDetail from '@/components/orderDetails/CustomOrderDetail';
import MallDemo from '@/components/orderDetails/MallDemo';
import MaintainDemo from '@/components/orderDetails/MaintainDemo';
import OrderEvaluate from '@/components/orderDetails/OrderEvaluate';
import LinkServiceContainer from './LinkServiceContainer';

export default {
  data() {
    return{
      url: '', // 动态url
      // 订单信息
      orderId: '',
      orderType: 0,
      orderStatus: 0,
      orderDetail: {},// 订单详情
      orderServiceInfo: {},// 订单服务（商品）信息
      orderData:[],// 订单基础信息-表格
      invoiceInfo: null,// 发票信息
      // 用户信息
      userinfo: {
        applyName: '',
        applyPhone: '',
        applyPosition: '',
        applyCorpName: '',
      },
      monthlyMarker: 0,//是否可月结
      payCloseTime: 0,// 支付关闭时间
      startTime: new Date(),// 今天
      timeInterval: null,
      cancelBtn: false,// 取消按钮
      payBtn: false,// 支付按钮
      rateBtn: false,// 评论按钮
      rateText:['非常不满意','不满意','一般','比较满意','非常满意',],
      showRate: false,
    }
  },
  methods: {
    getdetails() {
      this.$http.post(`${this.URL_PREFIX}${this.url}`, {
        orderId: this.orderId,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.orderDetail = res.data.resData;
          this.orderType = res.data.resData.orderType;
          this.orderStatus = res.data.resData.orderStatus;
          // 订单服务（商品）信息
          if(this.orderType === 9 || this.orderType === 12) {
            this.orderServiceInfo = this.orderDetail;
          } else if(this.orderDetail.orderServiceInfo) {
            this.orderServiceInfo = this.orderDetail.orderServiceInfo;
          }
          // 订单基础信息-表格
          this.orderData = [
            {
              createTime: this.orderDetail.createTime || '——',
              orderFee: this.orderDetail.orderFee/100,
              approvalFee: this.orderDetail.approvalFee/100,
              payFee:  this.orderDetail.payFee/100 || '——',
              payTime: this.orderDetail.payTime || '——',
              payLogId: this.orderDetail.payLogId || '——',
              orderStatus: this.getOrderStatusText(this.orderStatus, this.orderType),
            }
          ]
          // 发票信息
          this.invoiceInfo = this.orderDetail.invoiceInfo ? JSON.parse(this.orderDetail.invoiceInfo) : null;
          // 用户信息
          if(this.orderDetail.applyName){
            this.userinfo.applyName = this.orderDetail.applyName;
          }
          if(this.orderDetail.applyPhone){
            this.userinfo.applyPhone = this.orderDetail.applyPhone;
          }
          if(this.orderDetail.applyPosition){
            this.userinfo.applyPosition = this.orderDetail.applyPosition;
          }
          if(this.orderDetail.applyCorpName){
            this.userinfo.applyCorpName = this.orderDetail.applyCorpName;
          }
          // 是否可月结
          if(this.orderDetail.orderServiceInfo && this.orderDetail.orderServiceInfo.monthlyMarker){
            this.monthlyMarker = this.orderDetail.orderServiceInfo.monthlyMarker;
          }
          if((this.orderType === 9 || this.orderType === 12 || this.orderType === 13) && this.orderStatus === 5) {
            if (res.data.resData.payCloseTime) {
              this.payCloseTime = res.data.resData.payCloseTime; // 支付关闭时间
              if (this.startTime.getTime() <= this.payCloseTime) {
                this.timeInterval = setInterval(() => {
                  this.payCloseTime -= 1000;
                  if (this.payCloseTime <= this.startTime.getTime()) {
                    this.stopTime();
                    window.location.reload(); // 时间到了刷新页面
                  }
                }, 1000);
              }
            }
          }
          // 各按钮状态
          this.cancelBtn = false;
          if(this.orderStatus == 1 || this.orderStatus == 2 || this.orderStatus == 5) {
            if(this.orderType == 3 ||this.orderType == 10 || this.orderType == 16 || this.orderType == 12 || this.orderType == 13 || (this.orderType == 9 && this.orderStatus !== 1 ) ){
              this.cancelBtn = true;
            }
          }
          this.payBtn = this.orderStatus == 5 ? true : false;
          this.rateBtn = this.orderStatus == 6 && !this.orderDetail.servicesScore ? true : false;
        }
      });
    },
    makeurl() {
      switch (this.orderType) {
        case 3:
        case 10:
        case 16:
          this.url = '/app/get/park/service/form/order/detail'; // 自定义服务
          break;
        case 4:
          this.url = '/app/get/hr/job/order/detail'; // 找工作
          break;
        case 5:
          this.url = '/app/get/hr/service/order/detail'; // 服务外包
          break;
        case 6:
          this.url = '/app/get/hr/education/order/detail'; // 培训
          break;
        case 7:
          this.url = '/app/get/products/roadshow/order/detail'; // 产品路演
          break;
        case 8:
          this.url = '/app/get/ask/service/order/detail'; // 求购
          break;
        case 9:
          this.url = '/app/get/food/order/detail'; // 美食街
          break;
        case 11:
          this.url = '/app/get/fine/service/order/detail'; // 优选服务
          break;
        case 12:
          this.url = '/app/get/meeting/room/order/detail'; // 会议室
          break;
        case 13:
          this.url = '/app/get/activity/order/detail'; // 活动
          break;
        case 14:
          this.url = '/app/get/welfare/order/detail'; // 福利
          break;
        // case 15:
        //   this.url = ''; // 微社区
        //   break;
        case 17:
          this.url = '/app/get/shop/order/detail'; // 商城
          break;
        case 18:
          this.url = '/app/get/maintain/order/detail'; // 物业报修
          break;
        case 19:
          this.url = '/app/get/park/service/form/order/detail'; // 快递
          break;
        default:
      }
    },
    // 支付
    jumpPay(id) {
      let query = {
        orderId: this.orderId,
        orderType: this.orderType,
        monthlyMarker: this.monthlyMarker,
        price: this.orderDetail.approvalFee>0 ? this.orderDetail.approvalFee/100 : this.orderDetail.orderFee/100,
      }
      this.$router.push({ path: `/navigator/pay/paymentPage?`, query: query });
    },
    // 评分
    rateOrder(close, refresh) {
      this.showRate = close == true ? false : true;
      if(refresh == true){
        this.getdetails();
      }
    },
    // 取消订单
    cancelOrder() {
      let cancelUrl = '';
      switch (this.orderType) {
        case 3:
        case 10:
        case 16:// 自定义服务 入驻办理 自定义设施
          cancelUrl = '/app/delete/park/service/form/order';
          break;
        case 9:// 美食街
          cancelUrl = '/app/delete/food/order';
          break;
        case 12:// 会议室
          cancelUrl = '/app/delete/meeting/room/order';
          break;
        case 13:// 活动
          cancelUrl = '/app/cancel/activity/order';
          break;
        case 18:// 物业报修
          cancelUrl = '/app/cancel/maintain/order';
          break;
        case 19:// 快递
          cancelUrl = '/app/delete/park/service/form/order';
          break;
      }
      if (cancelUrl) {
        this.$http.post(`${this.URL_PREFIX}${cancelUrl}`, {orderId: this.orderId}, {
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode === '10000') {
            this.cancelBtn = false;
            this.getdetails();
          }else{
            this.$message.error(res.data.resDesc);
          }
        });
      }else{
        this.$message.error('订单类型不存在！');
      }
    },
    stopTime() {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    },
    getOrderStatusText(status, type) {
      switch (status){
        case 1:
          return type==9 ? '待接单' : '待审批';
        case 2:
          return '审批中';
        case 3:
          return '审批不通过';
        case 4:
          return '用户取消';
        case 5:
          return '待支付';
        case 6:
          return '完成';
        case 7:
          return '订单关闭';
        case 8:
          return '已退款';
        case 9:
          return '退款中';
        case 0:
          return '删除';
        default:
          return '——';
      }
    }
  },
  components: {
    CustomDemo, JobDemo, ServiceDemo, TrainingDemo, ProductionDemo, CooperationDemo, FoodDemo, RecommendedDemo, MeetingRoomDemo, ParkactivityDetails, ParkexclusiveActivities, CustomOrderDetail, MallDemo, MaintainDemo, OrderEvaluate, LinkServiceContainer,
  },
  computed: {
    ...mapGetters(['token', 'user']),

    time() {
      var endTime = this.payCloseTime;
      var t = endTime - this.startTime.getTime();
      var hour = Math.floor(t / 1000 / 3600);
      var min = Math.floor((t - hour * 3600 * 1000) / 1000 / 60);
      var sec = Math.floor((t - hour * 3600 * 1000 - min * 60 * 1000) / 1000 );
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (sec < 10) {
        sec = '0' + sec;
      }
      const countDownTime = hour > 0 ? `${hour}时${min}分${sec}秒` : `${min}分${sec}秒`;
      return countDownTime;
    },
  },
  created() {
    this.orderType = Number(this.$route.query.orderType);
    this.orderId = this.$route.query.orderId;
    this.userinfo.applyName = this.user.userCardInfo.name ? this.user.userCardInfo.name : this.user.userNick;
    this.userinfo.applyPosition = this.user.userCardInfo.position ? this.user.userCardInfo.position : '——';
    this.userinfo.applyCorpName = this.user.userCardInfo.corpName ? this.user.userCardInfo.corpName : '——';
    this.makeurl();
    this.getdetails();
  },
  beforeDestroy() {
    this.stopTime();
  },
  filters: {
    payType(ty) {
      if(ty === 1) {
        return '微信支付';
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.order-details{
  padding-bottom: 20px;
  .content{
    background-color: #fff;
    padding: 40px;
  }
}
.order-module{
  margin-top: 22px;
  font-size: 16px;
}
.order-base{
  margin-bottom: 10px;
}
.order-id{
  padding-left: 32px;
}
.pay-btn{
  text-align: right;
  margin-top: 26px;
}
.remarkTitle{
  font-size: 20px;
  padding: 10px 0;
  border-bottom: 2px solid #f6f6f6;
}
.remarkText{
  font-size: 16px;
  padding: 10px 0;
}
.text-label {
  display: inline-block;
  text-align: left;
  color: #999999;
  font-size: 14px;
  padding-right: 10px;
}
.pay-close-time{
  color: #FF6633;
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/personal/components/details/OrderDetails.vue